// 单实例回放:同一时刻只播一条 AI 语音。toggle(key) 再点同一条 = 停。
// playingKey 做外部 store,播放按钮用 useSyncExternalStore 订阅 → 切换 播放/停止 图标。
import { audioStore } from './audioStore'

let audio: HTMLAudioElement | null = null
let currentUrl: string | null = null
let playingKey: string | null = null
const listeners = new Set<() => void>()

function set(k: string | null) {
    playingKey = k
    for (const l of listeners) l()
}

function ensure(): HTMLAudioElement {
    if (!audio) {
        audio = document.createElement('audio')
        audio.hidden = true
        audio.onended = () => set(null)
        audio.onerror = () => set(null)
        document.body.appendChild(audio)
    }
    return audio
}

export const audioPlayer = {
    async toggle(key: string): Promise<void> {
        if (playingKey === key) {
            this.stop()
            return
        }
        const blob = await audioStore.getBlob(key)
        if (!blob) return
        const el = ensure()
        if (currentUrl) URL.revokeObjectURL(currentUrl)
        currentUrl = URL.createObjectURL(blob)
        el.src = currentUrl
        set(key)
        try {
            await el.play()
        } catch {
            set(null) // autoplay 受限等
        }
    },
    stop(): void {
        if (audio) {
            try {
                audio.pause()
            } catch {
                /* ignore */
            }
        }
        set(null)
    },
    subscribe(l: () => void): () => void {
        listeners.add(l)
        return () => listeners.delete(l)
    },
    getPlayingKey(): string | null {
        return playingKey
    }
}
